module.exports = __webpack_public_path__ + "img/file-alt-solid.c437ee46.svg";